module Meevo.Plugins.ReportingHierarchy {
    "use strict";
    
    export class BaseSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ReportingHierarchy> {
        constructor(params: Meevo.Model.ISectionParamsBaseDataService) {
            const {sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService} = params;

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService,null,null,null,params.sectionSecurityKey);
        }
    }
}